import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useRBAC, DEFAULT_REDIRECT } from '../contexts/RBACContext';
import Icon from './AppIcon';

const ProtectedRoute = ({ children, requiredRoles = null }) => {
  const { user, loading } = useAuth();
  const { role, canAccessRoute } = useRBAC();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <Icon name="Loader2" size={32} className="animate-spin text-primary" />
          <p className="text-muted-foreground text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  // Not authenticated → redirect to login
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check specific roles if provided
  if (requiredRoles && !requiredRoles?.includes(role)) {
    const redirectTo = DEFAULT_REDIRECT?.[role] || '/reservation-request';
    return <Navigate to={redirectTo} replace />;
  }

  // Check route-level access
  if (!canAccessRoute(location?.pathname)) {
    const redirectTo = DEFAULT_REDIRECT?.[role] || '/reservation-request';
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default ProtectedRoute;
